/* ═══════════════════════════════════════════════════════════════════════════
   THE MENU

   Ported from the prototype's `DISHES`, `DRINKS` and `MENUS`. The tenant's own
   food, prices, allergens and diets — nothing invented, and nothing added.

   ── `alc` is the load-bearing column ──────────────────────────────────────

   `0` no age limit · `18` alcohol · `20` spirits.

   The limits are alkoholloven § 1-5, and 20 applies to spirits **even when
   the spirits are inside a dessert** — which is why Coupe Colonel, a lemon
   sorbet with vodka on it, carries 20 and not 0. A menu that treated a
   dessert as food because it is served on a dessert plate would be the one
   mistake in this file that reaches a licence hearing.

   ── Allergens ─────────────────────────────────────────────────────────────

   On every line, because the registry's own rights list for this trade says
   allergen information must be given on request for every dish, and a list
   that is only sometimes filled in is one a waiter cannot trust.
   ═══════════════════════════════════════════════════════════════════════ */

/** The sections, in the order a menu is read. */
export const COURSES = [
  ['for', 'Forretter'],
  ['pizza', 'Fra vedovnen'],
  ['hoved', 'Hovedretter'],
  ['dessert', 'Desserter & ost'],
];

export const DIETS = {
  vegetar: 'Vegetar', vegansk: 'Vegansk',
  glutenfri: 'Glutenfri', laktosefri: 'Laktosefri',
};

/* n name · d description · p price · a allergens · t diets · alc age limit */
export const DISHES = [
  { c: 'for', n: 'Burrata & tomat', d: 'Grønne tomater, jalapeño & hyllblomst.', p: 245, a: ['melk'], t: ['vegetar', 'glutenfri'] },
  { c: 'for', n: 'Toast Skagen', d: 'Pepperrot, sitron, Kalix løyrom, dill & toast.', p: 285, a: ['gluten', 'egg', 'fisk', 'skalldyr', 'melk', 'sennep'], t: [] },
  { c: 'for', n: 'Kalix løyrom', d: 'Løyrom fra Kalix (30 g). Rødløk, sitron, rømme & toast.', p: 395, a: ['fisk', 'melk', 'gluten'], t: [] },
  { c: 'for', n: 'Skalldyrsuppe', d: 'Kongereke, fløte, estragon & espelettepepper.', p: 265, a: ['skalldyr', 'melk', 'fisk', 'selleri'], t: ['glutenfri'] },
  { c: 'for', n: 'Ricotta ravioli', d: 'Modne tomater, basilikum & parmesan.', p: 235, a: ['gluten', 'egg', 'melk'], t: ['vegetar'] },

  { c: 'hoved', n: 'Ovnsbakt torsk på salat', d: 'Bacon, Parmigiano Reggiano & krutonger.', p: 315, a: ['fisk', 'gluten', 'egg', 'melk', 'sennep'], t: [] },
  { c: 'hoved', n: 'Toast med kamskjell', d: 'Kamskjell, reddik, urteolje & ristet brød.', p: 345, a: ['gluten', 'blotdyr', 'melk', 'egg'], t: [] },
  { c: 'hoved', n: 'Dagens fangst', d: 'Med dagens tilbehør — spør din servitør.', p: 395, a: ['fisk', 'skalldyr', 'blotdyr', 'melk'], t: [] },
  { c: 'hoved', n: 'Piggvar', d: 'Kapers, blomkålpuré & soyasmør.', p: 445, a: ['fisk', 'melk', 'soya'], t: ['glutenfri'] },
  { c: 'hoved', n: 'Tagliata av oksefilet', d: 'Kapers, sennepsfrø, sjalottløk & grillet baguette.', p: 325, a: ['gluten', 'sennep'], t: [] },
  { c: 'hoved', n: 'Grilled cheeseburger', d: 'Peppermajones, cheddar, sylteagurk & pommes frites.', p: 295, a: ['gluten', 'egg', 'melk', 'sennep', 'sesam'], t: [] },
  { c: 'hoved', n: 'Trøffelfylt kylling', d: 'Vårprimører, estragon & kyllingvelouté.', p: 365, a: ['melk', 'selleri', 'gluten'], t: [] },
  { c: 'hoved', n: 'Grillet entrecôte', d: 'Tomatsalat, sauce béarnaise & pommes frites.', p: 435, a: ['egg', 'melk'], t: [] },
  { c: 'hoved', n: 'Grillet breiflabb', d: 'Tomatsalsa, sauce béarnaise & pommes frites.', p: 425, a: ['fisk', 'egg', 'melk'], t: [] },

  { c: 'dessert', n: 'Chocolat', d: 'Grand Marnier-krem, hasselnøttcrunch & saltkaramellkrem.', p: 175, a: ['melk', 'egg', 'notter', 'gluten', 'sulfitt'], t: ['vegetar'] },
  { c: 'dessert', n: 'Fraise', d: 'Yoghurt panna cotta, rabarbramarmelade & hibiskussorbet.', p: 165, a: ['melk'], t: ['vegetar', 'glutenfri'] },
  { c: 'dessert', n: 'Exotique', d: 'Kokosmousse, sambuca-infusert ananas & limesorbet.', p: 175, a: ['sulfitt'], t: ['vegetar', 'vegansk', 'glutenfri', 'laktosefri'] },
  /* Twenty, not zero. A sorbet with vodka on it is spirits served in a
     dessert bowl, and alkoholloven does not care what the bowl is. */
  { c: 'dessert', n: 'Coupe Colonel', d: 'Sitronsorbet & Purity vodka.', p: 155, alc: 20, a: [], t: ['vegetar', 'vegansk', 'glutenfri', 'laktosefri'] },
  { c: 'dessert', n: 'Macarons & sjokoladetrøfler', d: 'Spør din servitør om dagens utvalg.', p: 145, a: ['egg', 'melk', 'notter'], t: ['vegetar'] },
  { c: 'dessert', n: 'Modne oster', d: 'Liten eller stor tallerken. Fruktkompott & brød.', p: 195, a: ['melk', 'gluten', 'sulfitt'], t: ['vegetar'] },

  { c: 'pizza', n: 'Margherita', d: 'San Marzano-tomat, fior di latte, basilikum & olivenolje.', p: 245, a: ['gluten', 'melk'], t: ['vegetar'] },
  { c: 'pizza', n: 'Marinara', d: 'Tomat, hvitløk, oregano & olivenolje. Uten ost.', p: 225, a: ['gluten'], t: ['vegetar', 'vegansk', 'laktosefri'] },
  { c: 'pizza', n: 'Ortolana', d: 'Grillet squash, paprika, rødløk, oliven & fior di latte.', p: 275, a: ['gluten', 'melk'], t: ['vegetar'] },
  { c: 'pizza', n: 'Diavola', d: 'Sterk salami, tomat, fior di latte & chiliolje.', p: 289, a: ['gluten', 'melk'], t: [] },
  { c: 'pizza', n: 'Prosciutto e funghi', d: 'Skinke, sopp, tomat, fior di latte & timian.', p: 295, a: ['gluten', 'melk'], t: [] },
  { c: 'pizza', n: 'Quattro formaggi', d: 'Fior di latte, gorgonzola, parmesan, taleggio & honning.', p: 299, a: ['gluten', 'melk'], t: ['vegetar'] },
];

/* Which places serve what, and the note above their menu. `all` is the shared
   selection minus the pizzas — those belong to the wood oven at Pizzeria
   Nord, not on a brasserie's card. */
export const MENUS = {
  sabrura: { all: 1, intro: 'Klassisk brasserie. Menyen følger sesongen og byttes fire ganger i året.' },
  bryggen: { all: 1, intro: 'Råvarer fra Vestlandet, tilberedt enkelt. Kjøkkensjefen setter menyen hver uke.' },
  fjordbord: { only: [0, 1, 2, 7, 8, 13, 15, 16, 17], intro: 'Sjømat fra dagens fangst. Menyen bestemmes på kaia om morgenen.' },
  kafenord: { only: [0, 4, 20, 21, 22, 23, 24, 25, 9, 10, 14, 17, 18, 19], intro: 'Italiensk kjøkken fra vedfyrt ovn. Deigen hever i 48 timer og bakes på 450 grader.' },
};

/* ── What comes in a glass ────────────────────────────────────────────────
   `alc` on the GROUP, because a group is either alcoholic or it is not.
   "Aperitif & avec" is spirits and therefore twenty; wine and beer are
   eighteen. Both are derived in domain/menu.js rather than typed twice. */
export const DRINKS = [
  { g: 'Kaffe & te', alc: 0, rows: [
    { n: 'Espresso', d: 'Mørkbrent, ristet i Oslo.', p: 45 },
    { n: 'Dobbel espresso', d: '', p: 55 },
    { n: 'Cappuccino', d: 'Trukket på fersk melk.', p: 62 },
    { n: 'Kaffe på kanne', d: 'Filtermalt, fri påfyll.', p: 45 },
    { n: 'Te', d: 'Svart, grønn eller urte — spør din servitør.', p: 55 },
    { n: 'Varm sjokolade', d: 'Mørk sjokolade og pisket krem.', p: 68 }] },
  { g: 'Alkoholfritt', alc: 0, rows: [
    { n: 'Ferskpresset appelsinjuice', d: 'Presset ved bestilling.', p: 78 },
    { n: 'Eplemost fra Hardanger', d: 'Uklar, presset på Aroma og Discovery.', p: 68 },
    { n: 'Husets limonade', d: 'Sitron, timian og kullsyre.', p: 72 },
    { n: 'Alkoholfri aperitif', d: 'Bitter appelsin, rabarbra og tonic.', p: 95 },
    { n: 'Mineralvann', d: 'Stille eller med kullsyre, 33 cl.', p: 55 },
    { n: 'Brus', d: '33 cl.', p: 55 }] },
  { g: 'Vin, glass', alc: 1, rows: [
    { n: 'Hvitvin, 12 cl', d: 'Chardonnay, Bourgogne. Tørr, sitrus og eple.', p: 125 },
    { n: 'Rødvin, 12 cl', d: 'Sangiovese, Toscana. Middels fylde, kirsebær og urt.', p: 135 },
    { n: 'Musserende, 12 cl', d: 'Chardonnay og pinot noir. Tørr.', p: 145 },
    { n: 'Dessertvin, 8 cl', d: 'Sauternes. Søt, aprikos. Serveres til dessert.', p: 125 }] },
  { g: 'Vin, flaske', alc: 1, rows: [
    { n: 'Hvitvin, 75 cl', d: 'Chardonnay, Bourgogne. Tørr.', p: 545 },
    { n: 'Rødvin, 75 cl', d: 'Sangiovese, Toscana. Middels fylde.', p: 595 },
    { n: 'Musserende, 75 cl', d: 'Chardonnay og pinot noir. Tørr.', p: 795 },
    { n: 'Vinpakke, tre glass', d: 'Følger menyens tre retter.', p: 545 }] },
  { g: 'Øl & sider', alc: 1, rows: [
    { n: 'Fatøl, 0,4 l', d: 'Lys lager, 4,7 %.', p: 105 },
    { n: 'Fatøl, 0,3 l', d: 'Lys lager, 4,7 %.', p: 85 },
    { n: 'Flaskeøl', d: 'IPA, hveteøl eller mørk lager, 33 cl.', p: 115 },
    { n: 'Sider, 0,33 l', d: 'Tørr, eple. Hardanger.', p: 115 }] },
  { g: 'Aperitif & avec', alc: 1, rows: [
    { n: 'Aperitif, 4 cl', d: 'Bitter, urter.', p: 135 },
    { n: 'Cognac, 4 cl', d: 'VSOP.', p: 165 },
    { n: 'Whisky, 4 cl', d: 'Single malt, Skottland.', p: 155 },
    { n: 'Avec, 4 cl', d: 'Utvalg — spør din servitør.', p: 145 }] },
];

/** The tenant's own price level, from the prototype. */
export const PRICE_ADJ = { sabrura: 1, bryggen: 1.06, fjordbord: 1.1, kafenord: 0.88 };
